import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import MdText from '../../../../MdText';
import IconClose from '../../../../atoms/IconClose';
import IconArrowForward from '../../../../atoms/IconArrowForward';
import { getDiscountDisplay } from '../../../../helpers/discount';
import { MBox } from '../../../../atoms/MBox';
import MFlexbox from '../../../../atoms/MFlexbox';
import { MText } from '../../../../atoms/MText';
import { MButton } from '../../../../atoms/MButton';
import { MSelect } from '../../../../atoms/MSelect';
import { Modal } from '../../../../atoms/Modal';
import PriceDetails from '../../../../molecules/PriceDetails';

import {
  StyledVDTileEmbeddedWidgetCon,
  StyledVDOptionTileButton,
  StyledChooseVariant,
  InfoText,
} from './skins';

const TileLayout = props => {
  const {
    isMobile,
    theme,
    priceDetailStyles,
    vdOptions,
    variantOptions,
    selectedVariants,
    isATCLoading,
    totalDisplayValues,
    showVariantSelectorSection,
    variantSelectionSectionTitle,
    showMultipleVariantSelector,
    showVariantSelectorOnly,
    showFooter,
    showATCButton,
    getIsSelected,
    onChangeSelectedVDOption,
    onChangeVariant,
    onAddClick,
    isProductAdded,
    currencyFormat,
    currencySymbol,
    discountType,
    isAdmin,
    selectedVDOptionIndex,
  } = props;

  const getIsTotalOfferPriceAndTotalPriceSame = () => {
    if (vdOptions.length && vdOptions[selectedVDOptionIndex]) {
      const selectedVDOption = vdOptions[selectedVDOptionIndex];
      if (Number(selectedVDOption.discountValue) === 0) {
        return true;
      }
      return false;
    }
    return false;
  };

  const getQtyOptionStyles = isSelected => {
    const isBordered = theme.vdOptionIsBorderEnable;

    const result = {
      backgroundColor: theme.vdOptionBackgroundColor,
      textAlignment: 'center',
      padding: theme.vdOptionPadding,
      margin: theme.vdOptionMargin,
      height: isMobile ? theme.vdOptionMobileHeight : theme.vdOptionHeight,
      width: isMobile ? theme.vdOptionMobileWidth : theme.vdOptionWidth,
      ...(isBordered
        ? {
            borderColor: theme.vdOptionBorderColor,
            borderRadius: theme.vdOptionBorderRadius,
            borderWidth: theme.vdOptionBorderWidth,
          }
        : {
            borderColor: '',
            borderRadius: '0',
            borderWidth: '0',
          }),
    };

    if (isSelected) {
      result.backgroundColor = theme.vdOptionSelectedBackgroundColor;

      if (isBordered) {
        result.borderColor = theme.vdOptionSelectedBorderColor;
        result.borderRadius = theme.vdOptionSelectedBorderRadius;
        result.borderWidth = theme.vdOptionSelectedBorderWidth;
      }
    }

    return result;
  };

  const bannerWidth = isMobile
    ? theme.vdOptionBannerMobileWidth
    : theme.vdOptionBannerWidth;

  const getQtyOptionBannerWidth = isSelected =>
    Number(bannerWidth) -
    (theme.vdOptionIsBorderEnable
      ? Number(
          isSelected
            ? theme.vdOptionSelectedBorderWidth
            : theme.vdOptionBorderWidth,
        ) * 2
      : 0);

  const atcButtonWidth = isMobile
    ? theme.productButtonMobileWidth
    : theme.productButtonWidth;
  const vsButtonWidth = isMobile
    ? theme.productVariantMobileWidth
    : theme.productVariantWidth;

  const variantSelectorStyles = {
    style: theme.productVariantStyle,
    backgroundColor: theme.productVariantColor,
    borderColor: theme.productVariantColor,
    borderRadius: theme.productVariantBorderRadius,
    color: theme.productVariantTextColor,
    fontSize: isMobile
      ? theme.variantDropdownMobileFontSize
      : theme.variantDropdownFontSize,
    mobileFontSize: theme.variantDropdownMobileFontSize,
    fontStyle: theme.productVariantFontStyle,
    fontWeight: theme.productVariantFontWeight,
    textDecoration: theme.productVariantTextDecoration,
    fontFamily: theme.productVariantFontFamily,
    textAlignment: isMobile
      ? theme.productVariantMobileTextAlignment
      : theme.productVariantTextAlignment,
    padding: isMobile
      ? theme.productVariantMobilePadding
      : theme.productVariantPadding,
    margin: isMobile
      ? theme.productVariantMobileMargin
      : theme.productVariantMargin,
    height: isMobile
      ? theme.productVariantMobileHeight
      : theme.productVariantHeight,
    width: vsButtonWidth && vsButtonWidth !== '0' ? vsButtonWidth : '100%',
  };

  let atcStatus = theme.vdAddToCartText;

  if (isATCLoading) atcStatus = theme.atcProductAddingText;
  if (isProductAdded) atcStatus = theme.atcProductAddedText;

  const isATCInIntermediateState = isATCLoading || isProductAdded;

  const vdOptionDiscountText = theme.vdOptionDiscountText.slice();
  const vdPriceText = theme.vdPriceText.slice();
  const vdOfferPriceText = theme.vdOfferPriceText.slice();
  const vdPerItemText = theme.vdPerItemText.slice();

  const getPricesFromVariants = ({ variants }) => {
    if (!variants.length || !selectedVariants.length)
      return {
        offerPrice: '',
        price: '',
      };

    const selected = selectedVariants ? selectedVariants[0] : {};
    for (let i = 0; i < variants.length; i += 1) {
      const { offerPrice, price, spVariantID } = variants[i];
      if (spVariantID === selected.spVariantID) {
        return { offerPrice, price };
      }
    }
    return { offerPrice: '', price: '' };
  };

  const vdOptionTextStyles = {
    vdOptionTextColor: theme.vdOptionTextColor,
    vdOptionFontWeight: theme.vdOptionFontWeight,
    vdOptionFontStyle: theme.vdOptionFontStyle,
    vdOptionTextDecoration: theme.vdOptionTextDecoration,
    vdOptionFontSize: isMobile
      ? theme.vdOptionMobileFontSize
      : theme.vdOptionFontSize,
    vdOptionTextAlignment: theme.vdOptionTextAlignment,
    vdOptionTextPadding: isMobile
      ? theme.vdOptionTextMobilePadding
      : theme.vdOptionTextPadding,
    vdOptionTextMargin: theme.vdOptionTextMargin,
  };

  const vdOptionDiscountTextStyles = {
    vdOptionDiscountTextColor: theme.vdOptionDiscountTextColor,
    vdOptionDiscountFontWeight: theme.vdOptionDiscountFontWeight,
    vdOptionDiscountFontStyle: theme.vdOptionDiscountFontStyle,
    vdOptionDiscountFontSize: isMobile
      ? theme.vdOptionDiscountMobileFontSize
      : theme.vdOptionDiscountFontSize,
    vdOptionDiscountTextAlignment: theme.vdOptionDiscountTextAlignment,
    vdOptionDiscountPadding: isMobile
      ? theme.vdOptionDiscountMobilePadding
      : theme.vdOptionDiscountPadding,
    vdOptionDiscountMargin: theme.vdOptionDiscountMargin,
    vdOptionDiscountBackgroundColor: theme.vdOptionDiscountBackgroundColor,
    vdOptionDiscountBorderRadius: theme.vdOptionDiscountBorderRadius,
  };

  const vdPriceTextStyles = {
    vdPriceTextColor: theme.vdPriceTextColor,
    vdPriceFontWeight: theme.vdPriceFontWeight,
    vdPriceFontStyle: theme.vdPriceFontStyle,
    vdPriceFontSize: isMobile
      ? theme.vdPriceMobileFontSize
      : theme.vdPriceFontSize,
    vdPriceTextAlignment: theme.vdPriceTextAlignment,
    vdPricePadding: isMobile
      ? theme.vdPriceMobilePadding
      : theme.vdPricePadding,
    vdPriceMargin: theme.vdPriceMargin,
  };

  const vdOfferPriceTextStyles = {
    vdOfferPriceTextColor: theme.vdOfferPriceTextColor,
    vdOfferPriceFontWeight: theme.vdOfferPriceFontWeight,
    vdOfferPriceFontStyle: theme.vdOfferPriceFontStyle,
    vdOfferPriceFontSize: isMobile
      ? theme.vdOfferPriceMobileFontSize
      : theme.vdOfferPriceFontSize,
    vdOfferPriceTextAlignment: theme.vdOfferPriceTextAlignment,
    vdOfferPricePadding: isMobile
      ? theme.vdOfferPriceMobilePadding
      : theme.vdOfferPricePadding,
    vdOfferPriceTextMargin: theme.vdOfferPriceTextMargin,
  };

  const vdPerItemTextStyles = {
    vdPerItemTextColor: theme.vdPerItemTextColor,
    vdPerItemFontWeight: theme.vdPerItemFontWeight,
    vdPerItemFontStyle: theme.vdPerItemFontStyle,
    vdPerItemFontSize: isMobile
      ? theme.vdPerItemMobileFontSize
      : theme.vdPerItemFontSize,
    vdPerItemTextAlignment: theme.vdPerItemTextAlignment,
    vdPerItemPadding: isMobile
      ? theme.vdPerItemMobilePadding
      : theme.vdPerItemPadding,
    vdPerItemMargin: theme.vdPerItemMargin,
  };

  const [showVariantModal, setShowVariantModal] = React.useState(false);

  const offerPriceStyles = {
    fontStyle: theme.vdTotalFontStyle,
    fontWeight: theme.vdTotalFontWeight,
    textDecoration: theme.vdTotalTextDecoration,
    color: theme.vdTotalTextColor,
    fontSize: isMobile ? theme.vdTotalMobileFontSize : theme.vdTotalFontSize,
    mobileFontSize: theme.vdTotalMobileFontSize,
  };

  const priceStyles = {
    fontStyle: theme.vdTotalFontStyle,
    fontWeight: theme.vdTotalFontWeight,
    textDecoration: theme.vdTotalTextDecoration,
    color: theme.vdTotalTextColor,
    fontSize: isMobile ? theme.vdTotalMobileFontSize : theme.vdTotalFontSize,
    mobileFontSize: theme.vdTotalMobileFontSize,
  };

  const offStyles = {
    fontStyle: theme.vdTotalFontStyle,
    fontWeight: theme.vdTotalFontWeight,
    textDecoration: theme.vdTotalTextDecoration,
    color: theme.vdTotalTextColor,
    fontSize: isMobile ? theme.vdTotalMobileFontSize : theme.vdTotalFontSize,
    mobileFontSize: theme.vdTotalMobileFontSize,
  };

  return (
    <StyledVDTileEmbeddedWidgetCon
      positionRelativeDisabled={isAdmin}
      isMobile={isMobile}
      fontFamily={theme.font}
      backgroundColor={theme.offerBackgroundColor}
      border={
        theme.isOfferBordered
          ? `${theme.offerBorderWidth}px solid ${theme.offerBorderColor}`
          : ''
      }
      borderRadius={theme.widgetBorderRadius}
      padding={isMobile ? theme.widgetMobilePadding : theme.widgetPadding}
      margin={isMobile ? theme.widgetMobileMargin : theme.widgetMargin}
      mobilePadding={theme.widgetMobilePadding}
      mobileMargin={theme.widgetMobileMargin}
      className="mr-embedded-widget mr-embedded-widget--vd mr-embedded-widget--tile"
    >
      <MFlexbox
        padding={
          isMobile ? theme.offerHeaderMobilePadding : theme.offerHeaderPadding
        }
        margin={
          isMobile ? theme.offerHeaderMobileMargin : theme.offerHeaderMargin
        }
        jc={theme.offerHeaderTextAlignment}
      >
        <MdText
          fontSize={`${
            isMobile
              ? theme.offerHeaderMobileFontSize
              : theme.offerHeaderFontSize
          }px`}
          color={theme.offerHeaderTextColor}
          alignment={theme.offerHeaderTextAlignment}
        >
          {theme.offer_header_text}
        </MdText>
      </MFlexbox>
      {theme.offerSubtitleText && (
        <MFlexbox
          padding={
            isMobile
              ? theme.offerSubtitleMobilePadding
              : theme.offerSubtitlePadding
          }
          margin={
            isMobile
              ? theme.offerSubtitleMobileMargin
              : theme.offerSubtitleMargin
          }
          jc={theme.offerSubtitleTextAlignment}
        >
          <MdText
            fontSize={`${
              isMobile
                ? theme.offerSubtitleMobileFontSize
                : theme.offerSubtitleFontSize
            }px`}
            color={theme.offerSubtitleTextColor}
            alignment={theme.offerSubtitleTextAlignment}
          >
            {theme.offerSubtitleText}
          </MdText>
        </MFlexbox>
      )}
      <MFlexbox
        gap="10px"
        flexWrap={isMobile ? 'no-wrap' : 'wrap'}
        className="mr-embedded-widget__quantity-option-con"
        padding={theme.vdQuantityOptionContainerPadding}
        margin={theme.vdQuantityOptionContainerMargin}
      >
        {vdOptions.length !== 0 &&
          vdOptions.map((option, i) => {
            const isSelected = getIsSelected(option.id);
            const { offerPrice, price } = getPricesFromVariants({
              variants: option.variants,
            });

            return (
              <Fragment key={option.id}>
                <StyledVDOptionTileButton
                  className="mr-quantity-option"
                  onClick={() => onChangeSelectedVDOption(i)}
                  {...getQtyOptionStyles(isSelected)}
                  {...vdOptionTextStyles}
                  {...vdOptionDiscountTextStyles}
                  {...vdOfferPriceTextStyles}
                  {...vdPriceTextStyles}
                  {...vdPerItemTextStyles}
                >
                  {theme.vdOptionIsHighlightEnabled &&
                    option.highlightText.trim() !== '' && (
                      <MBox
                        backgroundColor={theme.vdOptionBannerBackgroundColor}
                        padding={theme.vdOptionBannerPadding}
                        margin={theme.vdOptionBannerMargin}
                        height={theme.vdOptionBannerHeight}
                        borderRadius={theme.vdOptionBannerBorderRadius}
                        width={getQtyOptionBannerWidth(isSelected)}
                        className="mr-quantity-option__banner-con"
                      >
                        <MText
                          fontSize={
                            isMobile
                              ? theme.vdOptionBannerMobileFontSize
                              : theme.vdOptionBannerFontSize
                          }
                          mobileFontSize={theme.vdOptionBannerMobileFontSize}
                          color={theme.vdOptionBannerTextColor}
                          fontStyle={theme.vdOptionBannerFontStyle}
                          fontWeight={theme.vdOptionBannerFontWeight}
                          textDecoration={theme.vdOptionBannerTextDecoration}
                          fontFamily={theme.vdOptionBannerFontFamily}
                          padding="0px"
                          margin="0px"
                          className="mr-quantity-option__banner-text"
                          textAlignment={theme.vdOptionBannerTextAlignment}
                          width="100%"
                        >
                          {option.highlightText}
                        </MText>
                      </MBox>
                    )}
                  <MFlexbox
                    flexDir="column"
                    className="mr-quantity-option_info-con"
                  >
                    <InfoText
                      className="mr-quantity-option_text"
                      fontFamily={theme.vdOptionFontFamily}
                    >
                      {option.optionText}
                    </InfoText>
                    {vdOptionDiscountText !== '' && (
                      <InfoText
                        hide={!+option.discountValue}
                        className="mr-quantity-option_discount-text"
                        fontFamily={theme.vdOptionDiscountFontFamily}
                      >
                        {getDiscountDisplay({
                          discount: option.discountValue,
                          discountValue: +option.discountValue,
                          discountType,
                          currencyFormat,
                          currencySymbol,
                          productDiscountText: vdOptionDiscountText,
                        })
                          .replace('{{discount}}', `${option.discountValue}`)
                          .replace('{{min}}', option.minValue)}
                      </InfoText>
                    )}
                    {vdPriceText !== '' && (
                      <InfoText
                        hide={!+option.discountValue}
                        className="mr-quantity-option_price-text"
                        fontFamily={theme.vdPriceFontFamily}
                      >
                        {vdPriceText.replace('{{price}}', price)}
                      </InfoText>
                    )}
                    {vdOfferPriceText !== '' && (
                      <InfoText
                        className="mr-quantity-option_offer-price-text"
                        fontFamily={theme.vdOfferPriceFontFamily}
                      >
                        {vdOfferPriceText.replace(
                          '{{offer_price}}',
                          offerPrice,
                        )}
                      </InfoText>
                    )}
                    {vdPerItemText !== '' && (
                      <InfoText
                        className="mr-quantity-option_per-item-text"
                        fontFamily={theme.vdPerItemFontFamily}
                      >
                        {vdPerItemText}
                      </InfoText>
                    )}
                  </MFlexbox>
                </StyledVDOptionTileButton>
              </Fragment>
            );
          })}
      </MFlexbox>

      {showVariantSelectorSection && (
        <StyledChooseVariant
          type="button"
          onClick={() => setShowVariantModal(true)}
          padding={theme.vdVariantSecPadding}
          margin={theme.vdVariantSecMargin}
          fontSize={`${
            isMobile
              ? theme.vdChooseVariantMobileFontSize
              : theme.vdChooseVariantFontSize
          }px`}
          color={theme.vdChooseVariantTextColor}
          fontStyle={theme.vdChooseVariantFontStyle}
          fontWeight={theme.vdChooseVariantFontWeight}
          textDecoration={theme.vdChooseVariantTextDecoration}
          textAlignment={
            isMobile
              ? theme.vdChooseVariantMobileTextAlignment
              : theme.vdChooseVariantTextAlignment
          }
        >
          <span className="choose-variant__text">
            {theme.vdChooseVariantText}
          </span>{' '}
          <IconArrowForward
            color={theme.vdChooseVariantTextColor}
            width="12"
            height="12"
          />
        </StyledChooseVariant>
      )}

      <Modal
        width="auto"
        isOpen={showVariantModal}
        absolute={isAdmin}
        onClose={() => setShowVariantModal(false)}
      >
        <MBox
          padding={theme.vdVariantSecPadding}
          margin={theme.vdVariantSecMargin}
          border={
            theme.vdVariantSecIsBorderEnable &&
            `${theme.vdVariantSecBorderWidth}px solid${
              theme.vdVariantSecBorderColor
            }`
          }
          borderRadius={
            theme.vdVariantSecIsBorderEnable && theme.vdVariantSecBorderRadius
          }
          backgroundColor={theme.vdVariantSecBackgroundColor}
          className="mr-vd-variant-section"
        >
          <MFlexbox
            ai
            jc="space-between"
            padding="20px"
            borderBottom="1px solid #E1E3E5"
          >
            <MText
              fontSize={
                isMobile
                  ? theme.vdVariantSecTitleMobileFontSize
                  : theme.vdVariantSecTitleFontSize
              }
              mobileFontSize={theme.vdVariantSecTitleMobileFontSize}
              color={theme.vdVariantSecTitleTextColor}
              fontStyle={theme.vdVariantSecTitleFontStyle}
              fontWeight={theme.vdVariantSecTitleFontWeight}
              textDecoration={theme.vdVariantSecTitleTextDecoration}
              fontFamily={theme.vdVariantSecTitleFontFamily}
              textAlignment={theme.vdVariantSecTitleTextAlignment}
              padding={theme.vdVariantSecTitlePadding}
              margin={theme.vdVariantSecTitleMargin}
              className="mr-vd-variant-section__title"
              width="100%"
            >
              {variantSelectionSectionTitle}
            </MText>

            <IconClose onClick={() => setShowVariantModal(false)} />
          </MFlexbox>

          <MBox padding="8px 12px">
            {showMultipleVariantSelector ? (
              <table className="mr-vd-variant-section__selector-table">
                <tbody className="mr-selector-table__body">
                  {selectedVariants.length !== 0 &&
                    selectedVariants.map((selectedVariant, i) => (
                      <tr
                        className="mr-selector-table__row"
                        key={`index-${i * 1}`}
                      >
                        <td className="mr-selector-table__product-index-cell">
                          <MText
                            fontSize={
                              isMobile
                                ? theme.vdVariantNumberingMobileFontSize
                                : theme.vdVariantNumberingFontSize
                            }
                            mobileFontSize={
                              theme.vdVariantNumberingMobileFontSize
                            }
                            color={theme.vdVariantNumberingTextColor}
                            fontStyle={theme.vdVariantNumberingFontStyle}
                            fontWeight={theme.vdVariantNumberingFontWeight}
                            textDecoration={
                              theme.vdVariantNumberingTextDecoration
                            }
                            fontFamily={theme.vdVariantNumberingFontFamily}
                            textAlignment={
                              theme.vdVariantNumberingTextAlignment
                            }
                            padding={theme.vdVariantNumberingPadding}
                            margin={theme.vdVariantNumberingMargin}
                            className="mr-vd-product-index"
                          >
                            {theme.vdVariantNumberingText.replace(
                              '{{number}}',
                              i + 1,
                            )}
                          </MText>
                        </td>
                        <td className="mr-selector-table__variant-selector-cell">
                          <div className="mr-variant-selector-con">
                            <div>
                              <MSelect
                                className="mr-vd-variant-selector"
                                value={selectedVariant.title}
                                options={variantOptions}
                                onChange={e => onChangeVariant(e, i)}
                                {...variantSelectorStyles}
                                width="401px"
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : (
              <>
                {showVariantSelectorOnly && (
                  <div className="mr-selector-table__variant-selector-cell">
                    <div className="mr-vd-variant-section__action-item">
                      <MSelect
                        className="mr-vd-variant-selector"
                        value={
                          selectedVariants.length > 0
                            ? selectedVariants[0].title
                            : ''
                        }
                        options={variantOptions}
                        onChange={e => onChangeVariant(e, 0)}
                        {...variantSelectorStyles}
                        width="401px"
                      />
                    </div>
                  </div>
                )}
              </>
            )}
          </MBox>
        </MBox>
      </Modal>

      {showFooter && (
        <MBox className="mr-vd-action-con">
          {theme.vdShowTotalPrice && (
            <MFlexbox
              gap="4px"
              ai="center"
              flexWrap="wrap"
              className="mr-vd-total-con"
              padding={theme.vdTotalPadding}
              margin={theme.vdTotalMargin}
              jc={theme.vdTotalTextAlignment}
            >
              <MText
                fontSize={
                  isMobile ? theme.vdTotalMobileFontSize : theme.vdTotalFontSize
                }
                mobileFontSize={theme.vdTotalMobileFontSize}
                color={theme.vdTotalTextColor}
                fontStyle={theme.vdTotalFontStyle}
                fontWeight={theme.vdTotalFontWeight}
                textDecoration={theme.vdTotalTextDecoration}
                fontFamily={theme.vdTotalFontFamily}
                className="mr-vd-total-con__text"
              >
                {theme.vdTotalText}
              </MText>
              <PriceDetails
                offerPrice={totalDisplayValues.offerPrice}
                price={totalDisplayValues.totalPrice}
                off={totalDisplayValues.discount}
                isDiscountDisabled={false}
                {...priceDetailStyles}
                className="mr-vd-total-con__price"
                fontSize={
                  isMobile ? theme.vdTotalMobileFontSize : theme.vdTotalFontSize
                }
                mobileFontSize={theme.vdTotalMobileFontSize}
                color={theme.vdTotalTextColor}
                fontStyle={theme.vdTotalFontStyle}
                fontWeight={theme.vdTotalFontWeight}
                textDecoration={theme.vdTotalTextDecoration}
                fontFamily={theme.vdTotalFontFamily}
                offerPriceStyles={offerPriceStyles}
                priceStyles={priceStyles}
                offStyles={offStyles}
                isTotalOfferPriceAndTotalPriceSame={getIsTotalOfferPriceAndTotalPriceSame()}
              />
            </MFlexbox>
          )}
          {showATCButton && (
            <MButton
              className="mr-vd-add-button"
              onClick={onAddClick}
              buttonStyle={theme.embeddedProductButtonStyle}
              backgroundColor={theme.productButtonColor}
              borderColor={theme.productButtonColor}
              borderRadius={theme.productButtonBorderRadius}
              textColor={theme.embeddedProductButtonTextColor}
              fontSize={
                isMobile
                  ? theme.productButtonMobileFontSize
                  : theme.productButtonFontSize
              }
              mobileFontSize={theme.productButtonMobileFontSize}
              fontStyle={theme.productButtonFontStyle}
              fontWeight={theme.productButtonFontWeight}
              textDecoration={theme.productButtonTextDecoration}
              textAlignment={theme.productButtonTextAlignment}
              fontFamily={theme.productButtonFontFamily}
              padding={theme.productButtonPadding}
              margin={theme.productButtonMargin}
              height={
                isMobile
                  ? theme.productButtonMobileHeight
                  : theme.productButtonHeight
              }
              width={
                atcButtonWidth && atcButtonWidth !== '0'
                  ? atcButtonWidth
                  : '100%'
              }
              disabled={isATCInIntermediateState}
              opacity={isATCInIntermediateState ? '0.7' : '1'}
            >
              {atcStatus}
            </MButton>
          )}
        </MBox>
      )}
    </StyledVDTileEmbeddedWidgetCon>
  );
};

TileLayout.propTypes = {
  isMobile: PropTypes.bool,
  theme: PropTypes.object,
  vdOptions: PropTypes.array,
  variantOptions: PropTypes.array,
  selectedVariants: PropTypes.array,
  isATCLoading: PropTypes.bool,
  totalDisplayValues: PropTypes.object,
  showVariantSelectorSection: PropTypes.bool,
  variantSelectionSectionTitle: PropTypes.string,
  showMultipleVariantSelector: PropTypes.bool,
  showVariantSelectorOnly: PropTypes.bool,
  showFooter: PropTypes.bool,
  showATCButton: PropTypes.bool,
  getIsSelected: PropTypes.func,
  getIfMoreVariantsAddable: PropTypes.func,
  getIfVariantRemovable: PropTypes.func,
  onChangeSelectedVDOption: PropTypes.func,
  onChangeVariant: PropTypes.func,
  onAddNewVariant: PropTypes.func,
  onRemoveSelectedVariant: PropTypes.func,
  onAddClick: PropTypes.func,
  priceDetailStyles: PropTypes.object,
  isProductAdded: PropTypes.bool,
  currencyFormat: PropTypes.string,
  currencySymbol: PropTypes.string,
  discountType: PropTypes.string,
  isAdmin: PropTypes.bool,
};

export default TileLayout;
